import { createFileRoute } from '@tanstack/react-router';

import { CitationBrowse } from '@/module/Author/Citation/CitationBrowse';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { chapterId } = Route.useParams();
  return <CitationBrowse publicationId={chapterId} />;
}
